<template>
    <section class="contact-us-area pt-80px pb-80px">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="contact-infos">
                        <h2>Contact Information</h2>
                        <p>Feel free to contact me for any questions or if you need any help or services ! I provide competitive insight and market analysis no one can duplicate. Analysis reveals opportunities, supports decisions, connects your SEO tactics and strategy directly to revenue.</p>
                        <ul>
                            <li class="address d-flex w-full">
                                <span class="icon">
                                    <el-icon><MapLocation /></el-icon>
                                </span>
                                <div class="right">
                                    <span>Address:</span>
                                    <p>Via Ufente, 20 04100 Latina Italy</p>
                                </div>
                            </li>
                            <li class="email d-flex w-full">
                                <span class="icon">
                                    <el-icon><Message /></el-icon>
                                </span>
                                <div class="right">
                                    <span>Email:</span>
                                    <p><a href="mailto:example@gmail.com">example@gmail.com</a></p>
                                </div>
                            </li>
                            <li class="phone d-flex w-full">
                                <span class="icon">
                                    <el-icon><Phone /></el-icon>
                                </span>
                                <div class="right">
                                    <span>Phone:</span>
                                    <p><a href="tel:+0493984838">+0493984838</a></p>
                                </div>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="col-md-8">
                    <div class="contact-form">
                        <el-form :model="contactForm" label-position="top">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="Name">
                                        <el-input v-model="contactForm.name" />
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="Email">
                                        <el-input type="email" v-model="contactForm.email" />
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="Phone">
                                        <el-input type="text" v-model="contactForm.phone" />
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="Subject">
                                        <el-input type="text" v-model="contactForm.subject" />
                                    </el-form-item>
                                </el-col>

                                <el-col :span="24">
                                    <el-form-item label="Message">
                                        <el-input type="textarea" v-model="contactForm.message" />
                                    </el-form-item>
                                </el-col>

                                <el-col :span="24">
                                    <el-button class="btn theme-btn">Send Message</el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { MapLocation, Message, Phone } from '@element-plus/icons-vue'
export default {
    name: 'ContactUsSection',
    components: {
        MapLocation,
        Message,
        Phone
    },
    data() {
        return {
            contactForm: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            }
        }
    }
}
</script>